//worked till now
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import Select from "react-select";

import ReactDatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { GetConversationApi } from "../../../api";
import {
  useAddConversationMutation,
  useEditConversationMutation,
} from "../../../redux/features/chat/conversations/conversationsApi";
import { useAddNewTuitionMutation } from "../../../redux/features/chat/tuitions/tuitionsApi";
import { authHeader, toastNotifiy } from "../../../Services/AuthVerify";
import { AddNotification } from "../../../Services/Notification.Service";
import "../../../style/custom-css/PersonalInfo.css";
import Multiselect from "multiselect-react-dropdown";

const ContactRequestModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [tuitions, setTuitions] = useState([]);
  const [tuitionsData, setTuitionsData] = useState([]);
  // post
  const [selectedTuition, setSelectedTuition] = useState([]);
  const [tuitionPlace, setTuitionPlace] = useState("");
  const [budget, setBudget] = useState("");
  const [currency, setCurrency] = useState(null);
  const [message, setMessage] = useState("");
  const [probableStartingDate, setProbableStartingDate] = useState(new Date());
  const { userId, name } = props.photoIndex || "";
  const [conversation, setConversation] = useState(undefined);
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const navigate = useNavigate();
  const [tuitionTypeList, setTuitionTypeList] = useState([]);
  const [selectedTuitionTypeOptions, setTuitionTypeSelectedOptions] = useState(
    []
  );
  const [tuitionType, setTuitionType] = useState(null);

  const [languageList, setLanguageList] = useState([]);
  const [selectedLanguageOptions, setLanguageSelectedOptions] = useState([]);
  const [languages, setLanguages] = useState(null);
  const [gender, setGender] = useState("");
  const [location, setLocation] = useState(null);

  const [
    addConversation,
    { isSuccess: isAddConversationSuccess, error: err1 },
  ] = useAddConversationMutation();
  const [
    editConversation,
    { isSuccess: isEditConversationSuccess, error: err2 },
  ] = useEditConversationMutation();

  const [addNewTuition, { isSuccess: isSaveTuition, error: err3 }] =
    useAddNewTuitionMutation();

  //validate budget
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [isValidBudget, setIsValidBudget] = useState(false);
  const [budgetErrorMessage, setBudgetErrorMessage] = useState(
    "budget cannot be negative"
  );

  const fnIsValidBudget = (Number) => {
    if (Number >= 0) return true;
    else return false;
  };

  useEffect(() => {
    if (!fnIsValidBudget(budget)) {
      setIsValidBudget(false);
      setShowErrorMessage(true);
    } else {
      setIsValidBudget(false);
      setShowErrorMessage(false);
    }
  }, [budget]);

  useEffect(() => {
    if (
      isAddConversationSuccess ||
      isEditConversationSuccess ||
      isSaveTuition
    ) {
      setLoading(false);
      if (isEditConversationSuccess) {
        navigate(
          `${process.env.PUBLIC_URL}/inbox/` // {conversation[0].conversationId
        );
      } else if (isAddConversationSuccess) {
        navigate(`${process.env.PUBLIC_URL}/inbox/`);
      } else if (isSaveTuition) {
        navigate(`${process.env.PUBLIC_URL}/inbox/`);
      } else {
        setLoading(false);
        alert("Something went wrong");
      }
    }
  }, [
    isAddConversationSuccess,
    isEditConversationSuccess,
    isSaveTuition,
    conversation,
    navigate,
  ]);
  useEffect(() => {
    var tuition = "";
    const subjectList = [];
    if (selectedTuition.length > 0) {
      selectedTuition?.map((item) => {
        subjectList.push(item.value);
      });
      tuition = subjectList.join(", ");
    }
    let remuneration = "";
    if (currency && budget >= 0) {
      if (budget) {
        remuneration =
          " I am offering a remuneration of [" +
          budget +
          " " +
          currency?.name +
          "] per hour.";
      }
    }
    setMessage(
      "Hi, " +
        name +
        ", I am looking for a student to help on '" +
        tuition +
        "'. Please let me know if you are available to learn this subject." +
        remuneration
    );
  }, [selectedTuition, budget]);

  const fnSetInitialField = async () => {
    setLoading(true);

    if (conversation === undefined || conversation?.length === 0) {
      const conv = await axios.get(GetConversationApi + userId, {
        headers: {
          Authorization: authHeader(),
        },
      });
      if (conv && conv.data) {
        setConversation(conv.data);
      } else {
        setConversation([]);
      }
    }
    var subjectList = [];
    if (props.photoIndex.tuitions) {
      setTuitionsData(props.photoIndex.tuitions);

      props.photoIndex.tuitions.subjects?.map((item, index) => {
        subjectList.push({
          value: item.name,
          //label: "[ " + item.tag + " ] " + item.name,
          label: item.name,
          tag: item.tag,
          id: item.id,
        });
      });
      setTuitions(subjectList);
      setSelectedTuition(subjectList);

      setTuitionTypeList(props.photoIndex.tuitions.tuitionTypes);
      setTuitionTypeSelectedOptions(props.photoIndex.tuitions.tuitionTypes);

      setLanguageSelectedOptions(props.photoIndex.tuitions.languages);
      setLanguageList(props.photoIndex.tuitions.languages);
      setGender(props.photoIndex.tuitions.gender);
      setLocation(props.photoIndex.tuitions.location);
    }

    setLoading(false);
  };

  useEffect(() => {
    setSelectedTuition([]);
    setTuitions([]);
    fnSetInitialField();
  }, [props]);

  const validateStartConversation = () => {
    if (selectedTuition === "" || selectedTuition.value === "") {
      toastNotifiy("Subjects is required", "warn");
      return false;
    } else if (selectedTuitionTypeOptions === "") {
      toastNotifiy("Tuition place is required ", "warn");
      return false;
    } else {
      return true;
    }
  };

  const handleStartConversation = async (e) => {
    e.preventDefault();
    setLoading(true);

    // check conversation
    if (selectedTuition) {
      if (!validateStartConversation()) {
        setLoading(false);
        return;
      }
      if (conversation?.length > 0) {
        // edit conversation
        editConversation({
          sender: loggedInUser,
          id: conversation[0].conversationId,
          data: {
            message,
          },
        });
      } else if (conversation?.length === 0) {
        // add conversation
        addConversation({
          sender: loggedInUser,
          data: {
            receiverId: userId,
            message,
            timestamp: new Date().getTime(),
          },
        });
      }
      tuitionsData.subjects = selectedTuition;
      addNewTuition({
        data: {
          studentId: userId,
          tutorId: loggedInUser,
          probableStartDate: probableStartingDate,
          tuitionRequest: tuitionsData,
          IsConfirmedByTutor: false,
          IsConfirmedByStudent: false,
        },
      });
      const notifyObj = {
        receiver: userId,
        title: "You have a new tuition request",
        description: "Someone Wants to contact with you",
        context: process.env.PUBLIC_URL + "/inbox",
        isPublic: false,
      };
      AddNotification(notifyObj);
    } else {
      if (!conversation) await fnSetInitialField();
      if (conversation?.length > 0) {
        // edit conversation
        editConversation({
          sender: loggedInUser,
          id: conversation[0].conversationId,
          data: {
            message,
          },
        });
      } else if (conversation?.length === 0) {
        // add conversation
        addConversation({
          sender: loggedInUser,
          data: {
            receiverId: userId,
            message,
            timestamp: new Date().getTime(),
          },
        });
      }
    }
  };
  const handlePreferredPlace = (e) => {
    setTuitionPlace(e.target.value);
  };
  const handleClose = () => {
    props.setPhotoIndex({ ...props.photoIndex, isOpen: false });
  };
  const handleProbableStartingDate = (date) => {
    setProbableStartingDate(new Date(date));
  };

  const handleSubjects = (item) => {
    if (!item) {
      setSelectedTuition([]);
      setCurrency([]);
      return;
    }
    setSelectedTuition(item);
    //const subjectInfo = tuitionsData.subjects?.filter((x) => x.id === item.value);
    //setCurrency(subjectInfo[0].currency);
  };

  return (
    <Fragment>
      <Modal
        isOpen={props.photoIndex.isOpen}
        toggle={props.photoIndex.toggler}
        style={{
          top: "0vh",
          right: "0vw",
        }}
        className="modal-lg"
        backdrop={"static"}
      >
        <ModalHeader style={{ placeContent: "center" }} toggle={handleClose}>
          <div>Start Conversation with {name}</div>
        </ModalHeader>
        <ModalBody className={"pb-0 " + props.bodyClass}>
          <Col sm="12" xl="12 box-col-12">
            <Card className="mb-0">
              <CardBody className="megaoptions-border-space-sm py-1">
                <Row>
                  <Col sm="12" xl="12">
                    <div>
                      <Row className="">
                        <Col md={4}>
                          <Label className="col-form-label" htmlFor="">
                            Student Subjects
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            isMulti
                            options={tuitions}
                            placeholder="Select Subjects"
                            className="js-example-basic-single col-sm-12 darkMode"
                            // onChange={(item) => handleSubjects(item)}
                            value={selectedTuition}
                            isClearable={true}
                            isDisabled
                          />
                        </Col>
                      </Row>
                    </div>
                    <Row className="align-items-center border-bottom">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          Preferred Language
                        </Label>
                      </Col>
                      <Col sm="8">
                        <Multiselect
                          className="darkMode bg-white"
                          isObject={false}
                          options={languageList}
                          showCheckbox
                          selectedValues={selectedLanguageOptions}
                          onSelect={(e) => {
                            setLanguages(e);
                          }}
                          onRemove={(e) => {
                            setLanguages(e);
                          }}
                          disable={true}
                        />
                      </Col>
                    </Row>
                    <Row className="align-items-center border-bottom">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          Tuition Place
                        </Label>
                      </Col>
                      <Col sm="8">
                        <Multiselect
                          className="darkMode bg-white"
                          isObject={false}
                          options={tuitionTypeList}
                          showCheckbox
                          onRemove={(e) => {
                            setTuitionType(e);
                          }}
                          onSelect={(e) => {
                            setTuitionType(e);
                          }}
                          selectedValues={selectedTuitionTypeOptions}
                          disable={true}
                        />
                      </Col>
                    </Row>
                    <Row className="align-items-center border-bottom">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          Gender
                        </Label>
                      </Col>
                      <Col sm="8">
                        <div
                          className="m-checkbox-inline"
                          style={{ paddingLeft: "6px" }}
                        >
                          <div className="radio radio-primary">
                            <Input
                              id="radioinline3"
                              type="radio"
                              name="radio1"
                              value={gender}
                              checked={gender == "0"}
                              onChange={(e) => setGender("0")}
                              disabled={true}
                            />

                            <Label className="mb-0" for="radioinline4">
                              <span className="digits"> {"All"}</span>
                            </Label>
                          </div>
                          <div className="radio radio-primary">
                            <Input
                              id="radioinline3"
                              type="radio"
                              name="radio1"
                              value={gender}
                              checked={gender == "male"}
                              onChange={(e) => setGender("male")}
                              disabled={true}
                            />
                            <Label className="mb-0" for="radioinline2">
                              <span className="digits"> {"Male"}</span>
                            </Label>
                          </div>
                          <div className="radio radio-primary">
                            <Input
                              id="radioinline3"
                              type="radio"
                              name="radio1"
                              value={gender}
                              checked={gender == "female"}
                              onChange={(e) => setGender("female")}
                              disabled={true}
                            />
                            <Label className="mb-0" for="radioinline3">
                              <span className="digits"> {"Female"}</span>
                            </Label>
                          </div>
                          <div className="radio radio-primary">
                            <Input
                              id="radioinline3"
                              type="radio"
                              name="radio1"
                              value={gender}
                              checked={gender == "other"}
                              onChange={(e) => setGender("other")}
                              disabled={true}
                            />
                            <Label className="mb-0" for="radioinline3">
                              <span className="digits"> {"Other"}</span>
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center border-bottom">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          Preferred Location
                        </Label>
                      </Col>
                      <Col sm="8">
                        <div>
                          {
                            <span>
                              <span
                                style={{
                                  margin: "0px 3px 2px 0px",
                                  fontSize: "12.5px",
                                }}
                                className="badge badge-light-primary py-1"
                              >
                                {location?.country}
                              </span>
                              <span
                                style={{
                                  margin: "0px 3px 2px 0px",
                                  fontSize: "12.5px",
                                }}
                                className="badge badge-light-primary py-1"
                              >
                                {location?.city}{" "}
                              </span>
                              <span
                                style={{
                                  margin: "0px 3px 2px 0px",
                                  fontSize: "12.5px",
                                }}
                                className="badge badge-light-primary py-1"
                              >
                                {location?.postalCode}
                              </span>
                            </span>
                          }
                        </div>
                      </Col>
                    </Row>
                    {props.photoIndex.tuitions?.education ? (
                      <Row className="align-items-center border-bottom">
                        <Col md={4}>
                          <Label
                            className="col-form-label"
                            htmlFor="inputEmail3"
                          >
                            Education
                          </Label>
                        </Col>
                        <Col sm="8">
                          <div>
                            {
                              <span>
                                <span
                                  style={{
                                    margin: "0px 3px 2px 0px",
                                    fontSize: "12.5px",
                                  }}
                                  className="badge badge-light-primary py-1"
                                >
                                  {
                                    props.photoIndex.tuitions?.education
                                      ?.degreeName
                                  }
                                </span>

                                <span
                                  style={{
                                    margin: "0px 3px 2px 0px",
                                    fontSize: "12.5px",
                                  }}
                                  className="badge badge-light-primary py-1"
                                >
                                  {
                                    props.photoIndex.tuitions?.education
                                      ?.courseName
                                  }
                                </span>
                                <span
                                  style={{
                                    margin: "0px 3px 2px 0px",
                                    fontSize: "12.5px",
                                  }}
                                  className="badge badge-light-primary py-1"
                                >
                                  {
                                    props.photoIndex.tuitions?.education
                                      ?.institute
                                  }
                                </span>
                              </span>
                            }
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    {props.photoIndex.tuitions?.workExperience ? (
                      <Row className="align-items-center border-bottom">
                        <Col md={4}>
                          <Label
                            className="col-form-label"
                            htmlFor="inputEmail3"
                          >
                            Work Experience
                          </Label>
                        </Col>
                        <Col sm="8">
                          <div>
                            {
                              <span>
                                <span
                                  style={{
                                    margin: "0px 3px 2px 0px",
                                    fontSize: "12.5px",
                                  }}
                                  className="badge badge-light-primary py-1"
                                >
                                  {
                                    props.photoIndex.tuitions?.workExperience
                                      ?.expYear
                                  }
                                </span>

                                <span
                                  style={{
                                    margin: "0px 3px 2px 0px",
                                    fontSize: "12.5px",
                                  }}
                                  className="badge badge-light-primary py-1"
                                >
                                  {
                                    props.photoIndex.tuitions?.workExperience
                                      ?.org
                                  }
                                </span>
                              </span>
                            }
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    {/* <Row className="py-1 align-items-center">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          Your Budget
                        </Label>
                      </Col>
                      <Col md={4} sm={6}>
                        <div style={{ display: "flex", placeItems: "center" }}>
                          <Input
                            type="number"
                            className="form-control"
                            placeholder="Enter Your Budget"
                            style={{ fontSize: "13px" }}
                            value={budget}
                            onChange={(e) => setBudget(e.target.value)}
                          />
                          <div>
                            <span className="px-2">/Hourly</span>
                          </div>
                        </div>
                        {showErrorMessage && !isValidBudget ? (
                          <div className="text-danger">
                            {budgetErrorMessage}
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col
                        md={4}
                        sm={6}
                        className={`py-1 ${currency !== null ? "" : "d-none"}`}
                      >
                        <div
                          className={`"border"`}
                          style={{
                            borderRadius: "5px",
                            background: "#e6e6e659",
                            lineHeight: "13px",
                            paddingTop: "3px",
                          }}
                        >
                          <span>{currency?.name} </span>
                          <p className="mb-0" style={{ fontSize: "10px" }}>
                            {currency?.code}
                          </p>
                        </div>
                      </Col>
                    </Row> */}
                    <Row className="mb-2">
                      <Col md={4}>
                        <Label className="col-form-label" htmlFor="">
                          Probable Starting Date
                        </Label>
                      </Col>
                      <Col md={4}>
                        <ReactDatePicker
                          className="form-control digits"
                          selected={probableStartingDate}
                          onChange={handleProbableStartingDate}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          minDate={new Date()}
                          dropdownMode="select"
                          dateFormat="dd MMMM yyyy"
                        />
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col md={12}>
                        <Input
                          type="textarea"
                          className="form-control"
                          rows="4"
                          style={{ fontSize: "13px" }}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm="12" xl="12">
                    <div className="row mb-2"></div>
                    <div className="row mb-2"></div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </ModalBody>
        <ModalFooter>
          <Btn
            attrBtn={{
              color: "primary",
              disabled: loading,
              onClick: (e) => handleStartConversation(e),
            }}
          >
            {/* {loading ? "LOADING..." : "Save changes"} */}
            {"Start Conversation"}
          </Btn>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default ContactRequestModal;
